/**
 * V2 Discover — pure derivations and the two segmented toggles. Split out of
 * discover.js on 2026-07-25 (843 lines, plan budget ~400). Nothing here
 * fetches or mounts: every function is a function of its arguments, which is
 * why these are the parts the tests could always exercise directly.
 * discover.js re-exports the public ones.
 */

/**
 * Chip data from the loaded yoinks — count is unique LOCATIONS per
 * category, V1's exact semantics (discovery.js:469-487); Uncategorized
 * hides from non-admins (:505,513). Exported for tests.
 */
export function deriveCategories(yoinks, isAdmin = false) {
  const byId = new Map();
  for (const y of yoinks) {
    const cat = y.categories;
    if (!cat?.id) continue;
    const entry = byId.get(cat.id) || { ...cat, locations: new Set() };
    if (y.location_id || y.locations?.id) entry.locations.add(y.location_id || y.locations.id);
    byId.set(cat.id, entry);
  }
  return [...byId.values()]
    .filter((c) => isAdmin || c.name !== 'Uncategorized')
    .map((c) => ({ ...c, count: c.locations.size }))
    .sort((a, b) => b.count - a.count);
}

/** People you follow first, otherwise keep the given order (stable sort). */
export function sortFollowedFirst(people, followingIds = []) {
  const followed = new Set(followingIds);
  return [...people].sort(
    (a, b) => (followed.has(b.id) ? 1 : 0) - (followed.has(a.id) ? 1 : 0)
  );
}

const CITY_OFFSET = 0.1; // V1 map.js calculateCityBounds: ±0.1° ≈ 7 miles

/** V1's city box around a point (map.js:222-237). Exported for tests. */
export function cityBounds(center, source = 'gps') {
  if (!center || center.lat == null || center.lng == null) return null;
  return {
    north: center.lat + CITY_OFFSET,
    south: center.lat - CITY_OFFSET,
    east: center.lng + CITY_OFFSET,
    west: center.lng - CITY_OFFSET,
    source,
  };
}

/** Grid / Map segmented toggle (mirrors the scope toggle). */
export function viewToggle(mode) {
  return `
    <div class="v2-scope" role="group" aria-label="View">
      <button class="v2-scope-btn ${mode === 'grid' ? 'scope-active' : ''}"
        data-view-mode="grid" aria-pressed="${mode === 'grid'}">Grid</button>
      <button class="v2-scope-btn ${mode === 'map' ? 'scope-active' : ''}"
        data-view-mode="map" aria-pressed="${mode === 'map'}">Map</button>
    </div>`;
}

/** All / Following segmented toggle — only rendered when signed in. */
export function scopeToggle(scope) {
  return `
    <div class="v2-scope" role="group" aria-label="Feed scope">
      <button class="v2-scope-btn ${scope === 'all' ? 'scope-active' : ''}"
        data-feed-scope="all" aria-pressed="${scope === 'all'}">All</button>
      <button class="v2-scope-btn ${scope === 'following' ? 'scope-active' : ''}"
        data-feed-scope="following" aria-pressed="${scope === 'following'}">Following</button>
    </div>`;
}
